import { Children } from 'react';
import * as React from 'react';
import classnames from 'classnames';







export const ClassNameInjector = ({
  className,
  children,
  onAnimationEnd }) =>
{
  if ( /*#__PURE__*/React.isValidElement(children)) {
    return /*#__PURE__*/React.cloneElement(Children.only(children), {
      className: classnames(children === null || children === void 0 ? void 0 : children.props.className, className),
      onAnimationEnd });

  }

  return null;
};